import axios from '@/config/httpConfig'

const modelName = "data"

/**
 * 测试连接数据源
 * @param id
 * @returns {Promise<unknown>}
 */
export function connect(id) {
    return axios.get("/" + modelName + "/source/connect/" + id);
}

/**
 * 拉取数据库信息
 * @param id 数据源id
 * @returns {Promise<unknown>}
 */
export function pullDataBase(id) {
    return axios.get("/" + modelName + "/dataBase/pull/" + id);
}

/**
 * 拉取数据库表
 * @param id 数据库id
 */
export function pullDataTable(id) {
    return axios.get("/" + modelName + "/table/pull/" + id);
}

/**
 * 按表前缀过滤表列表
 * @param dataBaseId 数据源ID
 * @param prefix 表前缀
 */
export function getTableListByPrefix(dataBaseId, prefix) {
    return axios.get("/" + modelName + "/table/listByPrefix", { dataBaseId, prefix });
}

/**
 * 拉取数据字段表
 * @param id 数据表id
 */
export function pullDataField(id) {
    return axios.get("/" + modelName + "/field/pull/" + id);
}

/**
 * 执行sql语句（勾选表）
 * @param data 勾选表数据
 */
export function handleEachTable(data) {
    return axios.post("/" + modelName + "/dataBase/executeOfTable", data);
}

/**
 * 代码预览
 *
 * @param id 表id
 * @param moduleId 模块id（可选，传了则从模块读取代码生成配置）
 * @returns {Promise | Promise<unknown>}
 */
export function codePreview(id, moduleId) {
    return axios.get("/" + modelName + "/table/code/show/" + id, { moduleId });
}

/**
 * 创建菜单，模板生成代码后，添加路由菜单
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
export function createMenu(id) {
    return axios.get("/" + modelName + "/table/menu/" + id)
}

/**
 * 获取项目列表
 * @returns {Promise<unknown>}
 */
export function getProjectList() {
    return axios.get("/" + modelName + "/project/list")
}

/**
 * 根据项目id获取模块列表
 * @param projectId 项目id
 * @returns {Promise<unknown>}
 */
export function getModuleListByProjectId(projectId) {
    return axios.get("/" + modelName + "/module/list/" + projectId)
}

/**
 * 创建模块
 * @param data 模块数据
 * @returns {Promise<unknown>}
 */
export function createModule(data) {
    return axios.post("/" + modelName +"/module", data)
}

/**
 * 删除模块
 * @param id 模块id
 * @returns {Promise<unknown>}
 */
export function deleteModule(id) {
    return axios.delete("/" + modelName + "/module/" + id)
}

/**
 * 根据项目id获取数据表数量
 * @param projectId 项目id
 * @returns {Promise<unknown>}
 */
export function getTableCountByProjectId(projectId) {
    return axios.get("/" + modelName + "/table/count/" + projectId)
}

/**
 * 根据项目id获取字段数量
 * @param projectId 项目id
 * @returns {Promise<unknown>}
 */
export function getFieldCountByProjectId(projectId) {
    return axios.get("/" + modelName + "/field/count/" + projectId)
}

export function executeTableSql(data) {
    return axios.post("/" + modelName + "/table/executeSql", data);
}

/**
 * 获取模块详情及其关联的数据库配置
 * @param id 模块id
 * @returns {Promise<unknown>}
 */
export function getModuleWithConfig(id) {
    return axios.get("/" + modelName + "/module/withConfig/" + id);
}

/**
 * 绑定模块到数据库配置
 * @param moduleId 模块id
 * @param dataBaseId 数据库配置id
 * @returns {Promise<unknown>}
 */
export function bindModuleConfig(moduleId, dataBaseId) {
    return axios.put("/" + modelName + "/module/" + moduleId + "/bindConfig/" + dataBaseId);
}

/**
 * 保存模块的完整数据库配置（含代码生成参数）
 * @param moduleId 模块id
 * @param dataBaseId 数据库id
 * @param data 配置参数（prefix, authorName, packageName 等）
 * @returns {Promise<unknown>}
 */
export function saveModuleConfig(moduleId, dataBaseId, data) {
    return axios.put("/" + modelName + "/module/" + moduleId + "/saveConfig/" + dataBaseId, data);
}

// ==================== 项目源码数字化模型 ====================

/**
 * 批量保存扫描结果
 * @param items 扫描结果列表（每个item自带projectId）
 * @returns {Promise<unknown>}
 */
export function batchSaveProjectModel(items) {
    return axios.post("/" + modelName + "/projectModel/batchSave", items);
}

/**
 * 清空项目的扫描数据
 * @param projectId
 * @returns {Promise<unknown>}
 */
export function clearProjectModel(projectId) {
    return axios.delete("/" + modelName + "/projectModel/clear/" + projectId);
}

/**
 * 获取项目下的所有模型
 * @param projectId
 * @returns {Promise<unknown>}
 */
export function getProjectModelList(projectId) {
    return axios.get("/" + modelName + "/projectModel/list/" + projectId);
}

/**
 * 获取列表接口code列表
 * @param projectId
 * @returns {Promise<unknown>}
 */
export function getProjectModelListCodes(projectId) {
    return axios.get("/" + modelName + "/projectModel/listCodes", { projectId });
}

/**
 * 获取树形接口code列表
 * @param projectId
 * @returns {Promise<unknown>}
 */
export function getProjectModelTreeCodes(projectId) {
    return axios.get("/" + modelName + "/projectModel/treeCodes", { projectId });
}

/**
 * 获取枚举code列表
 * @param projectId
 * @returns {Promise<unknown>}
 */
export function getProjectModelEnumCodes(projectId) {
    return axios.get("/" + modelName + "/projectModel/enumCodes", { projectId });
}

// ==================== 扫描策略 & 自定义脚本 ====================

/**
 * 更新项目(含扫描策略配置)
 * @param data { id, scanScriptId, aiDisclosure, ... }
 * @returns {Promise<unknown>}
 */
export function updateProject(data) {
    return axios.put("/" + modelName + "/project", data);
}

/**
 * 更新模块(含扫描策略配置)
 * @param data { id, scanScriptId, aiDisclosure, ... }
 * @returns {Promise<unknown>}
 */
export function updateModule(data) {
    return axios.put("/" + modelName + "/module", data);
}

/**
 * 获取项目详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function getProject(id) {
    return axios.get("/" + modelName + "/project/" + id);
}

// ---- 自定义扫描脚本 ----

export function getScanScriptList() {
    return axios.get("/" + modelName + "/scanScript/list");
}

export function createScanScript(data) {
    return axios.post("/" + modelName + "/scanScript", data);
}

export function updateScanScript(data) {
    return axios.put("/" + modelName + "/scanScript", data);
}

export function deleteScanScript(id) {
    return axios.delete("/" + modelName + "/scanScript/" + id);
}

/**
 * 批量更新字段标记
 * @param items 字段标记列表
 * @returns {Promise<unknown>}
 */
export function batchUpdateField(items) {
    return axios.put("/" + modelName + "/field/batchUpdate", items);
}
